import { axios, createFormData, handleError } from '../axios';

export const adminSetNewPassword = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post('admin/account/forgotten/password', createFormData(data))
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
          reject();
        }
      })
      .catch((e) => {
        handleError(e);
        reject();
      });
  });
};
